module.exports = __webpack_public_path__ + "img/oneCode.d0a3d36a.png";